import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AirportRegisterPageRoutingModule } from './airport-register-routing.module';

import { AirportRegisterPage } from './airport-register.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    AirportRegisterPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [AirportRegisterPage]
})
export class AirportRegisterPageModule {}
